import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { IApplication } from './application.model';

@Injectable({
    providedIn: 'root'
})
export class ApplicationService {
    private _http = inject(HttpClient);

    public getApplicationData(): Observable<IApplication[]> {
        return this._http.get<IApplication[]>(`applications`);
    }
}
